__turbopack_context__.v({
  "consCard": "AccommodationModal-module__PsjYfa__consCard",
  "consIcon": "AccommodationModal-module__PsjYfa__consIcon",
  "consItem": "AccommodationModal-module__PsjYfa__consItem",
  "consTitle": "AccommodationModal-module__PsjYfa__consTitle",
  "locationText": "AccommodationModal-module__PsjYfa__locationText",
  "mapLink": "AccommodationModal-module__PsjYfa__mapLink",
  "mapPlaceholder": "AccommodationModal-module__PsjYfa__mapPlaceholder",
  "modal": "AccommodationModal-module__PsjYfa__modal",
  "modalCloseBtn": "AccommodationModal-module__PsjYfa__modalCloseBtn",
  "modalContent": "AccommodationModal-module__PsjYfa__modalContent",
  "modalDivider": "AccommodationModal-module__PsjYfa__modalDivider",
  "modalHeader": "AccommodationModal-module__PsjYfa__modalHeader",
  "modalOverlay": "AccommodationModal-module__PsjYfa__modalOverlay",
  "modalSection": "AccommodationModal-module__PsjYfa__modalSection",
  "modalSectionTitle": "AccommodationModal-module__PsjYfa__modalSectionTitle",
  "modalText": "AccommodationModal-module__PsjYfa__modalText",
  "modalTitle": "AccommodationModal-module__PsjYfa__modalTitle",
  "priceCard": "AccommodationModal-module__PsjYfa__priceCard",
  "priceIcon": "AccommodationModal-module__PsjYfa__priceIcon",
  "priceNote": "AccommodationModal-module__PsjYfa__priceNote",
  "priceTitle": "AccommodationModal-module__PsjYfa__priceTitle",
  "prosCard": "AccommodationModal-module__PsjYfa__prosCard",
  "prosConsGrid": "AccommodationModal-module__PsjYfa__prosConsGrid",
  "prosConsHeader": "AccommodationModal-module__PsjYfa__prosConsHeader",
  "prosConsList": "AccommodationModal-module__PsjYfa__prosConsList",
  "prosIcon": "AccommodationModal-module__PsjYfa__prosIcon",
  "prosItem": "AccommodationModal-module__PsjYfa__prosItem",
  "prosTitle": "AccommodationModal-module__PsjYfa__prosTitle",
});
